module.exports = __webpack_public_path__ + "static/img/9_IMG_20160610_115640.e3809da8.jpg";